export enum AppUpdateFlags {
  FORCE = 'Force',
  SOFT = 'Soft',
}
